import { Component, OnInit } from '@angular/core';
import { AppConstants } from '../../config.service';
import { KeycloakService } from 'keycloak-angular';


@Component({
  selector: 'app-search-notifications',
  templateUrl: './search-notifications.component.html',
  styleUrls: ['./search-notifications.component.scss']
})
export class SearchNotificationsComponent implements OnInit {

  constructor(
    private appConstants: AppConstants,
    private keycloakService: KeycloakService
  ) { }



  searchNotificationData: any = {};
  getSearchNotificationData() {
    let modifiedObj = {};
    modifiedObj['endpoints'] = this.appConstants.endPoints;
    modifiedObj['userdetails'] = this.userInfo;
    this.searchNotificationData = { ...{}, ...modifiedObj }
    this.getToken();

    setInterval(() => {
      this.getToken()
    }, 1000);
  }


  sendToken: any = {};
  async getToken() {
    let token
    if (await this.keycloakService.isLoggedIn()) {
      token = await this.keycloakService.getToken();
      this.sendToken = Object.assign({}, {
        token: token
      })
    }
  }

  update(event) { }

  userInfo: any;
  ngOnInit() {
    this.isLoading = true;
    const user = this.appConstants.userDetails
    this.userInfo = user;
    this.getSearchNotificationData()
  }

  isLoading: boolean = false
  loadingEvent(event) {
    if (event && event.detail)
      this.isLoading = false
  }

}